import React from 'react'

function Mtab2() {
  return (
    <div>
        <ul className='list-disc list-inside'>

<li>We will have your car Repaired/or pay cash in case of loss or damage to the vehicle</li>
<li>We shall follow through the Settlement of claims arising from third party Bodily injury and third party property damage</li>
<li>We shall take care of any expenses incurred in processing claims, including having an advocate appointed represent you in court for third party claims</li>

</ul>




    </div>
  )
}

export default Mtab2